import { ApolloLink } from '@apollo/client';
export var createFetchPolicyLink = function createFetchPolicyLink() {
  return new ApolloLink(function (operation, forward) {
    var _operation$query$defi;
    var context = operation.getContext();
    if (context.fetchPolicy) {
      return forward(operation);
    }

    // First get the operation type
    var operationType = ((_operation$query$defi = operation.query.definitions[0]) === null || _operation$query$defi === void 0 ? void 0 : _operation$query$defi.kind) === 'OperationDefinition' ? operation.query.definitions[0].operation : null;

    // Then switch on the operation type
    switch (operationType) {
      case 'query':
        operation.setContext({
          fetchPolicy: 'cache-first'
        });
        break;
      case 'mutation':
      case 'subscription':
        operation.setContext({
          fetchPolicy: 'network-only'
        });
        break;
    }
    return forward(operation);
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/gql/links/fetchPolicyLink.js
// module id = 4115
// module chunks = 11